import {
  Button,
  Grid,
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

import format from "date-fns/format";
import React from "react";
import { Link, Prompt } from "react-router-dom";
import Component from "src/components/Component";
import Modal from "src/components/Modal";
import Page from "src/components/Page";
import PartialCleanCheck from "src/components/PartialCleanCheck";
import withAxios from "src/components/withAxios";
import l from "src/l";
import {
  IEvaluationRequest,
  ISurveyCoachEvaluationRequest,
  ISurveyEvalResponse,
  ISurveyEvaluationRequest,
  ISurveyScalarResponseSummaries,
  TemplateType,
  IDirectorParams,
  ISurveyComments,
  ISurveyResponse,
  IResponseSummaryRequest,
  IUser,
} from "src/services";
import { PersonType, hideColumn, roundToTen } from "src/util";
import { withSchoolContext } from "../../DirectorPage";
import EvaluationPrinter, {
  PrintEvaluationFunc,
} from "../evaluation/EvaluationPrinter";
import SurveyResponsesModal from "../evaluation/SurveyResponsesModal";
import CoachResponsemodal from "../evaluation/coachResponsemodal";
import GenerateReportModal from "../evaluation/reportGeneratemodal";
import CoachReportPreview from "../CoachReportPreview/CoachReportPreview";
import {
  getChampionsComparisonCoachScore,
  hasChampionsComparisonScores,
} from "../championsComparison";
import { styles } from "./styles";
import { IBaseProps, IProps, IViewEvalPageState } from "./types";
import { WiseLeadershipGridChart } from "./WiseLeadershipGridChart";
import { formatSummaryHeadings } from "../summaryFormatting";

const CoachReportPreviewAny: any = CoachReportPreview;
// import { CHAT_GPT_KEY } from "src/constants";

// const publicUrl = process.env.PUBLIC_URL;
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";

const customClass = {
  backgroundColor: "#e0e0e0",
  color: "rgba(0, 0, 0, 0.87)",
};
interface IChatGptRequest {
  coach_id: number;
  school_id: number;
  total_tokens: string;
  completion_tokens: string;
  prompt_tokens: string;
  chatgpttoken: string;
  chatgptRequest: string;
  chatgptResponse: string;
}
export default withSchoolContext<IBaseProps>(
  withStyles(styles)(
    withAxios(
      class extends Component<IProps, IViewEvalPageState & { reportLoading: boolean; isGeneratingReport: boolean }> {
        public readonly state = this.buildState({
          coachCommitments: "",
          deleteModalVisible: false,
          directorComments: "",
          parentComments: "",
          parentSurveyResponsesModalVisible: false,
          submitted: false,
          surveyResponsesModalVisible: false,
          coachResponsesModalVisible: false,
          reportGenerateModalVisible: false,
          schoolData: "",
          reportData: "",
          showLoader: false, // <-- add this
          showLoaderStudent: false, // <-- add this
          showLoaderParent: false, // <-- add this
          editButtonLoading: false,

          confirmGenerateReportOpen: false,
          reportLoading: false,
          isGeneratingReport: false,
          CoachReprot: false,
          reportButtonCalled:false
        });

        private saveChatGptHistory = this.buildPost<IChatGptRequest, any>(
          this,
          "chatgpt/createChatGpt"
        );
        
        private partialCleanCheck: PartialCleanCheck<IViewEvalPageState> =
          new PartialCleanCheck(this, [
            "coachCommitments",
            "directorComments",
            "parentComments",
          ]);

        private printEvaluation?: PrintEvaluationFunc;
        /** Sync print opener from preloaded CoachReportPreview (non-Champions). */
        private openPrintDataOnly: ((targetWindow?: any) => void) | null = null;
        /** Set when PRINT DATA ONLY is clicked before the preview opener is bound. */
        private pendingPrintDataOnly = false;

        private readonly parentCommentsChange = this.stateTextAreaEventHandler(
          (v) => ({ parentComments: v })
        );
        private readonly coachCommitmentsChange =
          this.stateTextAreaEventHandler((v) => ({ coachCommitments: v }));
        private readonly directorCommentsChange =
          this.stateTextAreaEventHandler((v) => ({ directorComments: v }));

        // public async componentDidMount() {

        //   const AdSpecificDashboard: any = await this.buildGet<IUser>(this, `/school/getOneSchools/${this.props.school.id}`)()
        //   this.setState({ schoolData: AdSpecificDashboard?.data })
        //   await this.loadAsync();
        //   await this.GetAllReoprt();
        
        //   document.body.classList.add("evaluation-pagess");
        // }


        public async componentDidMount() {
          // School data fetch
          const AdSpecificDashboard: any = await this.buildGet<IUser>(
            this,
            `/school/getOneSchools/${this.props.school.id}`
          )();
          this.setState({ schoolData: AdSpecificDashboard?.data });
        
          // Load other async data
          await this.loadAsync();
          await this.GetAllReoprt();
          // const { reportButtonCalled } = this.state; // destructure from state

          // ✅ Call checkAutomationSummary after data is loaded
          // const surveyYear = this.state.survey
          //   ? new Date(this.state.survey.responseCollectionEndDate).getFullYear()
          //   : new Date().getFullYear();
        
          // if (surveyYear >= 2025 && !( (this.props.school as { ismidseason?: boolean }).ismidseason ) && ! reportButtonCalled) {
          //   // Button show condition
          //   this.checkAutomationSummary(); // async function safe to call here
          // }
        
          document.body.classList.add("evaluation-pagess");
        }
        
        // public componentWillUnmount() {
        //   document.body.classList.remove("evaluation-pagess");
        // }
        // public async componentDidUpdate() {
        //    // ✅ Call checkAutomationSummary after data is loaded
        //    const { reportButtonCalled } = this.state; // destructure from state

        //    const surveyYear = this.state.survey
        //    ? new Date(this.state.survey.responseCollectionEndDate).getFullYear()
        //    : new Date().getFullYear();
       
        //  if (surveyYear >= 2025 && !( (this.props.school as { ismidseason?: boolean }).ismidseason ) && ! reportButtonCalled) {
        //    // Button show condition
        //    this.checkAutomationSummary(); // async function safe to call here
        //  }
        // }
        
        public componentWillUnmount() {
          document.body.classList.remove("evaluation-pagess");
        }

        public render() {
          const { school, coach, surveyId, sport } = this.props;
          const {
            loading,
            survey,
            surveyResponsesModalVisible,
            parentSurveyResponsesModalVisible,
            coachResponsesModalVisible, reportGenerateModalVisible
          } = this.state;
         
          return (
            <Page header={`View Survey ${school.isEmbeddable === true ? "" : sport.name}`}>
              {this.state.showLoader && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}
                >
                  <CircularProgress size={60} style={{ color: "#1976d2" }} />
                  <Typography style={{ marginTop: 24, color: "#fff", fontSize: 22 }}>
                    Summary generation in progress, please wait...
                  </Typography>
                </div>
              )}

{/* {(this.state.showLoaderStudent || this.state.showLoaderParent) && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}
                >
                  <CircularProgress size={60} style={{ color: "#1976d2" }} />
                  <Typography style={{ marginTop: 24, color: "#fff", fontSize: 22 }}>
                    Summary generation in progress, please wait...
                  </Typography>
                </div>
              )} */}

              {this.state.reportLoading && this.state.editButtonLoading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0,0,0,0.3)",
                    zIndex: 9999,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column"
                  }}
                >
                  <CircularProgress size={60} style={{ color: "#1976d2" }} />
                  <Typography style={{ marginTop: 24, color: "#fff", fontSize: 22 }}>
                    Loading report data, please wait...
                  </Typography>
                </div>
              )}
              {survey !== undefined && (
                <SurveyResponsesModal
                  schoolData={this.getDisplaySchoolData()}
                  startDate={survey.startDate}
                  endDate={survey.responseCollectionEndDate}
                  sport={sport}
                  coach={coach}
                  surveyId={surveyId}
                  schoolId={school.id}
                  slug={school.slug}
                  open={surveyResponsesModalVisible}
                  closeModal={this.closeSurveyResponseModal}
                />
              )}
              {survey !== undefined && (
                <SurveyResponsesModal
                  schoolData={this.getDisplaySchoolData()}
                  startDate={survey.startDate}
                  endDate={survey.responseCollectionEndDate}
                  sport={sport}
                  coach={coach}
                  surveyId={surveyId}
                  schoolId={school.id}
                  slug={school.slug}
                  open={parentSurveyResponsesModalVisible}
                  closeModal={this.closeParentSurveyResponseModal}
                  isParentModal={"true"}

                />
              )}
              {survey !== undefined && (
                <CoachResponsemodal
                  schoolData={this.getDisplaySchoolData()}
                  startDate={survey.startDate}
                  endDate={survey.responseCollectionEndDate}
                  sport={sport}
                  coach={coach}
                  surveyId={surveyId}
                  schoolId={school.id}
                  slug={school.slug}
                  open={coachResponsesModalVisible}
                  closeModal={this.closeCoachResponseModal}
                />
              )}
              {survey !== undefined && (
                <GenerateReportModal
                  ReportData={this.state.reportData}
                  schoolData={this.getDisplaySchoolData()}
                  startDate={survey.startDate}
                  endDate={survey.responseCollectionEndDate}
                  sport={sport}
                  coach={coach}
                  surveyId={surveyId}
                  schoolId={school.id}
                  slug={school.slug}
                  open={reportGenerateModalVisible}
                  closeModal={this.closeReoprtModal}
                  refreshReports={this.GetAllReoprt} // <-- yahan pass karein
              
                  bindGenerateReport={(fn) => { (this as any)._childGenerateReport = fn; console.log('[GenerateReportModal] bound child GenerateReport'); }}
                  showLoaderStudent={this.state.showLoaderStudent}
                  showLoaderParent={this.state.showLoaderParent}
                  editButtonLoading={this.state.editButtonLoading}
                  reportLoading={this.state.reportLoading}
                  isGeneratingReport={this.state.isGeneratingReport}
                  isCoachSelfAssessmentOnly={
                    survey.isCoachSelfAssessmentOnly ||
                    survey.entryLevel === 1 ||
                    survey.entryLevel === 3
                  }
                  isChampions101Survey={
                    survey.entryLevel >= 1 && survey.entryLevel <= 4
                  }

                />
              )}
              {survey !== undefined &&
                !(survey.entryLevel >= 1 && survey.entryLevel <= 4) && (
                <div
                  style={{
                    position: "fixed",
                    left: -10000,
                    top: 0,
                    width: "8.5in",
                    pointerEvents: "none",
                    opacity: 0,
                    zIndex: -1,
                  }}
                  aria-hidden={true}
                >
                  <CoachReportPreviewAny
                    schoolId={school.id}
                    sportId={sport && sport.id}
                    coachId={coach && coach.id}
                    surveyId={surveyId}
                    year={new Date(survey.startDate ?? Date.now()).getFullYear()}
                    type="coach"
                    isParentResponses={false}
                    readOnly={true}
                    pageName="evalprintform"
                    survey={survey}
                    coachName={coach && coach.name}
                    schoolName={school && school.name}
                    sportName={sport && sport.name}
                    schoolLogoUrl={school && school.logo1}
                    isAdSurvey={this.isAdSurvey()}
                    primaryColor={
                      (this.getDisplaySchoolData() as any) &&
                      (this.getDisplaySchoolData() as any).primaryColor
                    }
                    reportId={
                      Array.isArray(this.state.reportData) &&
                      this.state.reportData[0] &&
                      this.state.reportData[0].id
                        ? this.state.reportData[0].id
                        : undefined
                    }
                    bindOpenPrint={(fn: ((targetWindow?: any) => void) | null) => {
                      this.openPrintDataOnly = fn;
                      if (fn && this.pendingPrintDataOnly) {
                        this.pendingPrintDataOnly = false;
                        fn();
                      }
                    }}
                  />
                </div>
              )}
              {this.renderDeleteModal()}
              <EvaluationPrinter printEvaluationRef={this.setPrintEvaluation} />
              <Prompt
                when={!this.partialCleanCheck.isClean()}
                message="You have unsaved changes. Are you sure you want to leave?"
              />
              {loading ? <LinearProgress /> : null}
              {survey === undefined ? null : (
                <React.Fragment>
                  {this.renderButtons()}
                  {this.renderEval()}
                  <Grid style={{ marginTop: 16 }}>{this.renderButtons()}</Grid>
                </React.Fragment>
              )}
              {loading ? <LinearProgress /> : null}
            </Page>
          );
        }

        private isAdSurvey = () => {
          const { school, sport } = this.props;
          const schoolData = this.state.schoolData as any;
          const flags = [
            schoolData?.isAdSurvey,
            schoolData?.isAdSurveyStatus,
            (school as any)?.isAdSurvey,
            (school as any)?.isAdSurveyStatus,
          ];

          return (
            flags.some((flag) => flag === true || flag === "true" || flag === 1 || flag === "1") ||
            String(schoolData?.slug || (school as any)?.slug || "").includes("ADSurveys") ||
            String(sport?.name || "").toLowerCase().startsWith("ad ")
          );
        };

        private getDisplaySchoolData = () => ({
          ...(typeof this.state.schoolData === "object" ? this.state.schoolData : {}),
          isAdSurvey: this.isAdSurvey(),
        });

        private GetAllReoprt = async () => {
          const { coach, school, sport } = this.props;
          const { survey } = this.state;
          if (!survey) {
            return;
          }
          const startTs = survey?.startDate ?? Date.now();
          const dateObj = new Date(startTs);

          // Get only year
          const year = dateObj.getFullYear();
          // "year":"2024"


          try {
            this.setState({ reportLoading: true });
            // Example API call (replace with your actual API and params)
            const ReportData = await this.buildPost<{ sportId: any, coachId: any, type: any, schoolId: any, year: string }, any>(
              this, "/reports/reportGetAll"
            )({
              schoolId: school.id,
              sportId: sport.id,
              coachId: coach.id,
              type: "coach",
              year: year.toString()

              // startDate: survey?.startDate,
              // endDate: survey?.responseCollectionEndDate

            });
            this.setState({
              reportData: ReportData?.data, schoolData: ReportData?.school
            });
          } catch (error) {
            console.error("Error in ReportData", error);
          } finally {
            this.setState({ reportLoading: false });
          }
        }
        private openReoprtModal = async (skipGetAllReoprt: boolean = false) => {
          if (!skipGetAllReoprt) {
            await this.GetAllReoprt();
          }
          this.setState({ reportGenerateModalVisible: true }, () => {
            console.log('[openReoprtModal] modal visible:', this.state.reportGenerateModalVisible);
          });
        };
        private closeReoprtModal = () =>
          this.setState({ reportGenerateModalVisible: false }, () => {
            console.log('[closeReoprtModal] modal visible:', this.state.reportGenerateModalVisible);
          });

        private openSurveyResponsesModal = () =>
          this.setState({ surveyResponsesModalVisible: true });

        private closeSurveyResponseModal = () =>
          this.setState({ surveyResponsesModalVisible: false });

        private openCoachResponsesModal = () =>
          this.setState({ coachResponsesModalVisible: true });

        private closeCoachResponseModal = () =>
          this.setState({ coachResponsesModalVisible: false });


        private openParentSurveyResponsesModal = () =>
          this.setState({ parentSurveyResponsesModalVisible: true });

        private closeParentSurveyResponseModal = () =>
          this.setState({ parentSurveyResponsesModalVisible: false });

        // private openDelete = () => this.setState({ deleteModalVisible: true });

        private closeDeleteModal = () =>
          this.setState({ deleteModalVisible: false });

        private deleteSurvey = () =>
          void this.runCancellableStatefulAsync(
            this,
            {},
            {},
            async () => {
              const { surveyId, school, sport } = this.props;
              if (surveyId === undefined) {
                throw new Error("Survey Id does not exist");
              }
              await this.buildPut<IEvaluationRequest, {}>(
                this,
                `survey/delete/${surveyId}`
              )({
                schoolId: school.id,
                sportId: sport.id,
              });
              this.props.history.push(`/${school.slug}/dashboard`);
            },
            () => {
              alert("Failed to delete");
            }
          );

        private renderDeleteModal() {
          const { sport } = this.props;
          const { deleteModalVisible, survey } = this.state;
          return (
            <Modal
              open={deleteModalVisible && survey !== undefined}
              closeModal={this.closeDeleteModal}
            >
              <Grid
                style={{ height: "100%" }}
                container={true}
                direction="column"
                justifyContent="space-between"
              >
                <Grid>
                  <h1>{this.props.school.isEmbeddable === true ? "" : sport.name}</h1>
                  <br />
                  <span>
                    <span style={{ color: "red" }}>WARNING!</span> This will
                    delete surveys for each coach on this survey for this date.
                    Are you sure you want to continue?
                  </span>
                </Grid>
                <Grid container={true} justifyContent="space-between">
                  <Button onClick={this.closeDeleteModal} variant="contained">
                    Back
                  </Button>
                  <Button
                    onClick={this.deleteSurvey}
                    variant="contained"
                    color="secondary"
                  >
                    Delete
                  </Button>
                </Grid>
              </Grid>
            </Modal>
          );
        }

        private renderButtons() {
          const { classes } = this.props;
          // const { loading, showPrintButton, submitted } = this.state;
          const { loading, showPrintButton, submitted, confirmGenerateReportOpen } = this.state;



          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Button
                  disabled={loading || this.partialCleanCheck.isClean()}
                  onClick={this.updateEvaluation(false, "SaveAll")}
                  className={classes.button}
                  color="primary"
                  variant="contained"
                >
                  Save Comments
                </Button>
                {/* / /==============dummy button=============== */}
                {/* <Button
                  onClick={() => {
                    console.log('[renderButtons] Confirm dialog -> Yes, Generate clicked');
                    this.openReoprtModal(true);
                    if ((this as any)._childGenerateReport) {
                      console.log('[renderButtons] invoking child GenerateReport');
                      (this as any)._childGenerateReport();
                    } else {
                      console.warn('[renderButtons] child GenerateReport not bound yet');
                    }
                    this.setState({ confirmGenerateReportOpen: false });
                  }}
                  color="primary"
                  variant="contained"
                  disabled={loading}
                >
                  Yes, Generate
                </Button> */}
                {/* //=================================          */}


                {/* <Button
  onClick={async () => {
    const { survey } = this.state;
    this.openReoprtModal(true);

    if (survey && survey.questions) {
      try {
        // 1️⃣ Child ko bas normal call (await nahi)
        (this as any)._childGenerateReport?.();
        console.log("Child clause ✅ called");

        // 2️⃣ Student ko await karo
        const studentResult = await this.GenerateSummaryHandle(
          survey.questions,
          "student"
        );
        console.log("Student clause ✅ success", studentResult);

        // 3️⃣ Parent ko await karo
        const parentResult = await this.GenerateSummaryHandle(
          survey.questions,
          "parent"
        );
        console.log("Parent clause ✅ success", parentResult);
      } catch (error) {
        console.error("❌ Error while generating report:", error);
      } finally {
        // ✅ Modal hamesha open hoga
        this.setState({ confirmGenerateReportOpen: false });
      }
    }
  }}
  color="primary"
  variant="contained"
  disabled={this.state.loading}
>
  Yes, Generate
</Button> */}

                {/* //==================================== */}
                <Button
                  className={`${classes.button} ${submitted ? classes.submitted : classes.notSubmitted
                    }`}
                  disabled={loading}
                  onClick={this.updateEvaluation(true, "MarkCompletion")}
                  color="primary"
                  variant="contained"
                >
                  {submitted ? "Completed" : "Mark Completed"}
                </Button>


                {(() => {
                  // Get the year from survey data
                  // const surveyYear = this.state.survey ? new Date(this.state.survey.responseCollectionEndDate).getFullYear() : new Date().getFullYear();
                  const surveyYear = this.state.survey ? new Date(this.state.survey.startDate).getFullYear() : new Date().getFullYear();

                  console.log("this.state.survey 123",this.state.survey)
                  // const shouldShowReportButtons = surveyYear >= 2022;
                  // const shouldShowReportButtons = surveyYear >= 2022 && !this.props.school as { ismidseason?: boolean }).ismidseason;
                  const shouldShowReportButtons =surveyYear >= 2025 && !( (this.props.school as { ismidseason?: boolean }).ismidseason );
                
                  // console.log(shouldShowReportButtons, "shouldShowReportButtons")
                  const hasReportData = Array.isArray(this.state.reportData)
                    ? this.state.reportData.length > 0
                    : !!this.state.reportData;
                    console.log("hasReportData",hasReportData)
                  const hasGeneratedReport = Array.isArray(this.state.reportData)
                    ? this.state.reportData.some((row: any) => Number(row?.reportGeneratedCount) >= 1)
                    : Number((this.state.reportData as any)?.reportGeneratedCount) >= 1;

                  
                  // Only show report buttons if year is 2025 or greater
                  if (!shouldShowReportButtons) {
                    // console.log("Only show report buttons if year is 2025 or greater but your but not ")
                    return null;
                  }

                  const generateReportControls = (
                    <>
                      <Button
                        style={customClass}
                        className={`${classes.customeClass} ${classes.button} ${submitted ? classes.submitted : classes.notSubmitted
                          } `}
                        disabled={loading || this.state.reportLoading}
                        onClick={() => {
                          // console.log('[renderButtons] Generate clicked -> open confirm dialog');
                            this.setState({ confirmGenerateReportOpen: true })
                        }}
                        variant="contained"
                      >
                        Generate Report

                      </Button>

                      <Dialog
                        open={confirmGenerateReportOpen}
                        onClose={() => {
                            // console.log('[renderButtons] Confirm dialog closed (Cancel/Backdrop)');
                            this.setState({ confirmGenerateReportOpen: false })
                          }}
                        maxWidth="sm"
                        aria-labelledby="confirm-report-dialog"
                      >
                        <DialogTitle>Confirm Report Generation</DialogTitle>
                        <DialogContent>
                          Are you sure all your data is recorded? You can only generate this summary report once.
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => {
                                this.setState({ confirmGenerateReportOpen: false })
                              }}
                            color="secondary"
                          >
                            Cancel
                          </Button>
                          
                          <Button
                            onClick={async () => {
                              const { survey } = this.state;
                              this.setState({ confirmGenerateReportOpen: false });
                              setTimeout(async () => {
                                await new Promise<void>((resolve) => {
                                  this.setState({ isGeneratingReport: true }, resolve);
                                });
                                // Keep the progress modal visible while summaries and report are generated.
                                this.openReoprtModal(true);
                                try {
                                  // Save both summaries before creating the report snapshot.
                                  if (survey && survey.questions) {
                                    await this.GenerateSummaryHandle(survey.questions, "student");
                                    await this.GenerateSummaryHandle(survey.questions, "parent");
                                  }

                                  // Wait for report generation and the refreshed report list.
                                  await (this as any)._childGenerateReport?.();
                                  await this.GetAllReoprt();

                                } catch (error) {
                                  console.error("❌ Error while generating report:", error);
                                } finally {
                                  this.setState({
                                    confirmGenerateReportOpen: false,
                                    isGeneratingReport: false,
                                  });
                                }
                              }, 350);
                            }}
                            color="primary"
                            variant="contained"
                            disabled={this.state.loading}
                          >
                            Yes, Generate
                          </Button>





                        </DialogActions>
                      </Dialog>
                    </>
                  );

                  return (
                    <> 
                    {!hasGeneratedReport && generateReportControls}
                    <Button
                      style={customClass}
                      className={`${classes.customeClass} ${classes.button} ${submitted ? classes.submitted : classes.notSubmitted
                        } `}
                      // disabled={loading || this.state.reportLoading}
                      onClick={() => {
                        this.openReoprtModal(false);
                        this.setState({ editButtonLoading:true})
                        this.checkAutomationSummary()
                      }}
                      variant="contained"
                    >
                      {/* Edit Report */}
                      PRINT / EDIT REPORT 
                    </Button>
                    {/* {this.checkAutomationSummary?.()} */}
                     </>
 
                  );
                })()}

                {showPrintButton && (
                  <Button
                    onClick={() => {
                      const { coach, school, surveyId } = this.props;
                      const { survey } = this.state;
                      const isChampions101 =
                        !!survey &&
                        survey.entryLevel >= 1 &&
                        survey.entryLevel <= 4;

                      // Champions 101: keep previous EvalPrintForm / backend print UI.
                      if (isChampions101) {
                        if (this.printEvaluation === undefined) {
                          throw new Error("There is not print");
                        }
                        const updatedSchool = {
                          ...school,
                          CoachReprot: false,
                        } as any;
                        this.printEvaluation(updatedSchool, surveyId, coach.id);
                        return;
                      }

                      // New/no-report print uses CoachReportPreview.
                      // Legacy saved payloads continue to use the old EvaluationPrinter design.
                      const reportRow =
                        Array.isArray(this.state.reportData) &&
                        this.state.reportData[0]
                          ? this.state.reportData[0]
                          : null;
                      const reportPayload =
                        this.getParsedCoachReportPayload(reportRow);
                      const hasSavedReportData = Array.isArray(this.state.reportData)
                        ? this.state.reportData.length > 0
                        : !!this.state.reportData;
                      const useNewDesign =
                        Boolean((school as { ismidseason?: boolean }).ismidseason) ||
                        !hasSavedReportData ||
                        this.isCoachFrontendShapeReport(reportPayload);

                      if (useNewDesign) {
                        if (this.openPrintDataOnly) {
                          this.openPrintDataOnly();
                        } else {
                          this.pendingPrintDataOnly = true;
                        }
                        return;
                      }

                      if (this.printEvaluation === undefined) {
                        throw new Error("There is not print");
                      }
                      const updatedSchool = {
                        ...school,
                        CoachReprot: false,
                      } as any;
                      this.printEvaluation(updatedSchool, surveyId, coach.id);
                    }}
                    className={classes.button}
                    variant="contained"
                  >
                    {/* Print */}
                    PRINT DATA ONLY
                  </Button>
                )}

                <Button
                  onClick={this.openSurveyResponsesModal}
                  className={classes.button}
                  color="secondary"
                  variant="contained"
                >
                  {this.isAdSurvey() ? "SHOW COACH RESPONSES" : "Show Individual Responses"}
                </Button>
                <Button
                  onClick={this.openParentSurveyResponsesModal}
                  className={classes.button}
                  color="secondary"
                  variant="contained"
                >
                  {this.isAdSurvey() ? "SHOW PARENT RESPONSES" : "Show Parent Responses"}
                </Button>
                <Button
                  onClick={this.openCoachResponsesModal}
                  className={classes.button}
                  color="secondary"
                  variant="contained"
                >
                  {this.isAdSurvey() ? "SHOW AD RESPONSE" : "Show Coach Responses"}
                </Button>
              </div>
              {/* TODO: move this elsewhere for better UX */}
              {/* <Button
                style={{ alignSelf: "right" }}
                onClick={this.openDelete}
                className={classes.button}
                color="secondary"
                variant="outlined"
              >
                Delete
              </Button> */}
            </div>
          );
        }

        private renderEval() {
          const { survey } = this.state;
          return survey === undefined ? null : (
            <div>
              {this.renderEvalHeader(survey)}
              <Table className={this.props.classes.table}>
                {this.renderQuestionsTable(
                  survey,
                  "expectations",
                  "Expectations"
                )}
                {this.renderQuestionsTable(
                  survey,
                  "warmth",
                  "Relational Warmth"
                )}
                {this.renderQuestionsTable(survey, "other", "Written Response")}
              </Table>
              {/* {this.renderChampionsComparisonTable(survey)} */}
              <hr />
              {this.renderCommentsGraph(survey, "student", this.isAdSurvey() ? "Coach" : "Athlete")}
              {this.renderBottomSection(survey)}
            </div>
          );
        }

        private renderEvalHeader(survey: ISurveyEvalResponse) {
          const { coach } = this.props;
          return (
            <span>
              <Grid
                container={true}
                direction="row"
                justifyContent="space-between"
              >
                <Typography variant="h3">{coach.name}</Typography>
              </Grid>
              <Typography
                style={{ fontSize: "1.4em", color: "#585858" }}
              >{`${format(survey.startDate, "MMMM D, YYYY")} to ${format(
                survey.responseCollectionEndDate,
                "MMMM D, YYYY"
              )} \u2022 ${survey.count.studentCount + " " + (this.isAdSurvey() ? "Coach" : "Student")}  , ${survey.count.parentCount
                } Parent, ${survey.count.coachCount + " " + (this.isAdSurvey() ? "AD" : "Coach")
                } Responses.`}</Typography>
            </span>
          );
        }

        /*
          There is a lot of repeated code here and should be addressed once the new updates 
          are finalized. Currently, there is so set idea of where person questions should reside
        */
        private renderQuestionsTable(
          survey: ISurveyEvalResponse,
          key: keyof ISurveyScalarResponseSummaries,
          heading: string
        ) {
          const { classes } = this.props;

          const scaleResponseSummaries = survey.scaleResponseSummaries[key];
          if (scaleResponseSummaries.averages.length === 0) {
            return null;
          }
          const hideCoachColumn = hideColumn(PersonType.coach, survey, {
            scale: scaleResponseSummaries.averages.map((a) => a.coachScore),
          });
          const hideStudentColumn = hideColumn(PersonType.student, survey, {
            scale: scaleResponseSummaries.averages.map((a) => a.studentScore),
          });
          const hideParentColumn = hideColumn(PersonType.parent, survey, {
            scale: scaleResponseSummaries.averages.map((a) => a.parentScore),
          });
          const showChampionsCoachScoreColumn =
            hasChampionsComparisonScores(survey) && key !== "parent";
          const comparisonCoachScores = scaleResponseSummaries.averages
            .map((question, index) =>
              getChampionsComparisonCoachScore(
                survey,
                question.category,
                question.order,
                index
              )
            )
            .filter((score): score is number => score !== undefined && score >= 0);
          const comparisonCoachAverage =
            comparisonCoachScores.length === 0
              ? undefined
              : comparisonCoachScores.reduce((sum, score) => sum + score, 0) /
                comparisonCoachScores.length;
          const renderOptionalScore = (score: number | undefined) =>
            score === undefined ? "N/A" : roundToTen(score);
          return (
            <React.Fragment>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="h5" className={classes.bold}>
                      {heading}
                    </Typography>
                  </TableCell>
                  {hideStudentColumn ? null : (
                    <TableCell>{this.isAdSurvey() ? "Coach Average" : "Student Average"}</TableCell>
                  )}
                  {showChampionsCoachScoreColumn ? (
                    <TableCell>Coach Score</TableCell>
                  ) : null}
                  {hideParentColumn ? null : (
                    <TableCell>Parent Score</TableCell>
                  )}
                  {hideCoachColumn || showChampionsCoachScoreColumn ? null : <TableCell>
                    {this.isAdSurvey() ? "AD Score" : "Leader Score"}</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {scaleResponseSummaries.averages.map((question, i: number) => (
                  <TableRow key={i}>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.text}
                    >
                      {question.text}
                    </TableCell>
                    {hideStudentColumn ? null : (
                      <TableCell>{roundToTen(question.studentScore)}</TableCell>
                    )}
                    {showChampionsCoachScoreColumn ? (
                      <TableCell>
                        {renderOptionalScore(
                          getChampionsComparisonCoachScore(
                            survey,
                            question.category,
                            question.order,
                            i
                          )
                        )}
                      </TableCell>
                    ) : null}
                    {hideParentColumn ? null : (
                      <TableCell>{roundToTen(question.parentScore)}</TableCell>
                    )}
                    {hideCoachColumn || showChampionsCoachScoreColumn ? null : (
                      <TableCell>{roundToTen(question.coachScore)}</TableCell>
                    )}
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell>
                    <Grid
                      container={true}
                      direction="row"
                      justifyContent="flex-end"
                    >
                      <Typography className={classes.bold}>
                        {heading} Average
                      </Typography>
                    </Grid>
                  </TableCell>
                  {hideStudentColumn ? null : (
                    <TableCell>
                      <Typography className={classes.bold}>
                        {roundToTen(scaleResponseSummaries.studentTotalAverage)}
                      </Typography>
                    </TableCell>
                  )}
                  {showChampionsCoachScoreColumn ? (
                    <TableCell>
                      <Typography className={classes.bold}>
                        {renderOptionalScore(comparisonCoachAverage)}
                      </Typography>
                    </TableCell>
                  ) : null}
                  {hideParentColumn ? null : (
                    <TableCell>
                      <Typography className={classes.bold}>
                        {roundToTen(scaleResponseSummaries.parentTotalAverage)}
                      </Typography>
                    </TableCell>
                  )}
                  {hideCoachColumn || showChampionsCoachScoreColumn ? null : (
                    <TableCell>
                      <Typography className={classes.bold}>
                        {roundToTen(scaleResponseSummaries.coachTotalAverage)}
                      </Typography>
                    </TableCell>
                  )}
                </TableRow>
              </TableBody>
            </React.Fragment>
          );
        }

        // private renderChampionsComparisonTable(survey: ISurveyEvalResponse) {
        //   const { classes } = this.props;
        //   const rows = buildChampionsComparisonRows(survey);

        //   if (rows.length === 0) {
        //     return null;
        //   }

        //   return (
        //     <>
        //       <Typography className={classes.header} variant="h5">
        //         Student / Coach Comparison
        //       </Typography>
        //       <Table className={classes.table}>
        //         <TableHead>
        //           <TableRow>
        //             <TableCell>
        //               <Typography variant="h5" className={classes.bold}>
        //                 Student Question
        //               </Typography>
        //             </TableCell>
        //             <TableCell>Student Average Score</TableCell>
        //             <TableCell>Coach Score</TableCell>
        //           </TableRow>
        //         </TableHead>
        //         <TableBody>
        //           {rows.map((row, index) => (
        //             <TableRow key={index}>
        //               <TableCell className={classes.text}>
        //                 {row.question}
        //               </TableCell>
        //               <TableCell>
        //                 {row.studentScore >= 0 ? roundToTen(row.studentScore) : "N/A"}
        //               </TableCell>
        //               <TableCell>
        //                 {row.coachScore >= 0 ? roundToTen(row.coachScore) : "N/A"}
        //               </TableCell>
        //             </TableRow>
        //           ))}
        //         </TableBody>
        //       </Table>
        //     </>
        //   );
        // }

        private renderCommentsGraph(
          survey: ISurveyEvalResponse,
          type: "parent" | "student",
          header: string,
          defaultHideCoachColumn = false
        ) {
          const { classes, coach, school, surveyId, sport } = this.props;
          const isChampions101 =
            survey.entryLevel >= 1 && survey.entryLevel <= 4;
          const hideAthleteColumn =
            type === "student" &&
            isChampions101 &&
            (survey.entryLevel === 1 || survey.entryLevel === 3);
          if (!survey.hasWrittenQuestions) {
            return null;
          }
          if (
            !hideAthleteColumn &&
            hideColumn(
              type === "student" ? PersonType.student : PersonType.parent,
              survey,
              // TODO: Fix TypeScript flagged issue
              // @ts-ignore
              { written: survey.questions.map((q) => q[type + "Text"]) }
            )
          ) {
            return;
          }

          const questions = survey.questions;

          const shouldHideCoachColumn = hideColumn(PersonType.coach, survey, {
            written: questions.map((q) => {
              const writtenCoachSummary = survey.coachResponses.find(
                (res) => res.surveyQuestionId === q.id
              );
              return writtenCoachSummary === undefined
                ? ""
                : writtenCoachSummary.response;
            }),
          });

          const hideCoachColumn =
            defaultHideCoachColumn || shouldHideCoachColumn;

          return (
            <div>
              <Grid container={true} direction="row" wrap="wrap" spacing={1}>
                <Grid container={true} spacing={1}>

                  {!hideAthleteColumn && (
                    <Grid item={true} xs={6}>
                      <Typography className={classes.header} variant="h5">
                        {header} Comment Summaries
                      </Typography>
                    </Grid>
                  )}
                  {hideCoachColumn ? null : (
                    <Grid item={true} xs={hideAthleteColumn ? 12 : 6}>
                      <Typography className={classes.header} variant="h5">
                        {this.isAdSurvey() ? "AD" : "Coach"} Comments
                      </Typography>
                    </Grid>
                  )}
                </Grid>
                {questions.map((question, index) => {
                  const writtenSummary = survey.writtenResponseSummaries.find(
                    (response) => response.surveyQuestionId === question.id
                  );
                  const otherQuestionText = question[`${type}Text`];
                  const otherSummaryText =
                    writtenSummary?.[`${type}Summary`] ?? null;
                  const rawStudentComments =
                    type === "student" && isChampions101
                      ? writtenSummary?.studentComments ?? []
                      : [];

                  const writtenCoachSummary = survey.coachResponses.find(
                    (response) => response.surveyQuestionId === question.id
                  );
                  const coachQuestionText = question.coachText;
                  const coachSummaryText =
                    writtenCoachSummary?.response ?? null;

                  const renderQuestionText = (questionText: string) => {
                    return (
                      <span
                        style={{ alignSelf: "flex-end" }}
                        className={classes.text}
                      >
                        {questionText}
                      </span>
                    );
                  };

                  // const renderWrittenSummary = (summaryText: string | null) => {
                  //   return (
                  //     <p className={`${classes.summaryBox} ${classes.text}`}>
                  //       {summaryText}
                  //     </p>
                  //   );
                  // };


                  const renderWrittenSummary = (
                    summaryText: string | null,
                    useRawStudentComments = false
                  ) => {
                    if (
                      useRawStudentComments &&
                      type === "student" &&
                      isChampions101 &&
                      !writtenSummary?.studentCommentsEdited
                    ) {
                      return (
                        <div className={`${classes.summaryBox} ${classes.text}`}>
                          {rawStudentComments.map((comment, commentIndex) => (
                            <p key={commentIndex} style={{ whiteSpace: "pre-wrap" }}>
                              {comment}
                            </p>
                          ))}
                        </div>
                      );
                    }
                    if (summaryText) {
                      const lines = summaryText.split('\n');

                      return (
                        <div className={`${classes.summaryBox} ${classes.text}`}>
                          {lines.map((line, index) => {
                            // Split each line at the first colon
                            const [beforeColon, afterColon] = line.split(':');
                            return (
                              <p key={index}>
                                {afterColon ? (
                                  <>
                                    <strong>{beforeColon}</strong>: {afterColon.trim()}
                                  </>
                                ) : (
                                  line // Render the full line if no colon is present
                                )}
                              </p>
                            );
                          })}
                        </div>
                      );
                    }
                    return <div className={`${classes.summaryBox} ${classes.text}`} />;
                  };

                  return (
                    <React.Fragment key={index}>
                      <Grid container={true} spacing={1}>
                        {!hideAthleteColumn && (
                          <Grid item={true} xs={6} style={{ display: "flex" }}>
                            {renderQuestionText(otherQuestionText)}
                          </Grid>
                        )}
                        {!hideCoachColumn && (
                          <Grid item={true} xs={hideAthleteColumn ? 12 : 6} style={{ display: "flex" }}>
                            {renderQuestionText(coachQuestionText)}
                          </Grid>
                        )}
                      </Grid>
                      <Grid container={true} spacing={1}>
                        {!hideAthleteColumn && (
                          <Grid item={true} xs={6}>
                            {otherQuestionText &&
                              renderWrittenSummary(otherSummaryText, true)}
                          </Grid>
                        )}
                        {!hideCoachColumn && (
                          <Grid item={true} xs={6}>
                            {/* Only render summary if there is a question */}
                            {coachQuestionText &&
                              renderWrittenSummary(coachSummaryText)}
                          </Grid>
                        )}
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </Grid>
              <div className="sector-respon d-flex" >
                {!hideAthleteColumn && <Button
                  style={{ color: "#fff" }}
                  className={classes.bottomButton}
                  color="secondary"
                  variant="contained"
                  component={Link}
                  {...({
                    to: `/${school.slug}/comments/${surveyId}/${sport.id}/${coach.id
                      }/${type === "student" ? 1 : 2}`,
                  } as any)}
                >
                  {/* Edit {this.state.schoolData?.isAdSurvey === true && header === "Coach" ? "Ad" : header} Comments */}
                  Edit {header} Comments
                </Button>}
                {(type === "student" && !isChampions101) && (
                  <Typography>
                    <Button
                      style={{ marginTop: "8px", marginLeft: "10px" }}
                      variant="contained"
                      color="primary"
                      onClick={() => { this.handleGenerateSummary(questions, 'student') }}
                    >
                      {
                        // Check if any student summary exists for these questions
                        questions.some(q =>
                          (survey.writtenResponseSummaries.find(r => r.surveyQuestionId === q.id)?.studentSummary || "").trim().length > 0
                        )
                          ? "REGENERATE AI SUMMARIES "
                          : "GENERATE AI SUMMARIES"
                      }
                    </Button></Typography>
                )}
                {(type === "parent") && (
                  <Typography>
                    <Button
                      style={{ marginTop: "8px", marginLeft: "10px" }}
                      variant="contained"
                      color="primary"
                      onClick={() => { this.handleGenerateSummary(questions, 'parent') }}
                    >
                      {
                        // Check if any parent summary exists for these questions
                        questions.some(q =>
                          (survey.writtenResponseSummaries.find(r => r.surveyQuestionId === q.id)?.parentSummary || "").trim().length > 0
                        )
                          ? "REGENERATE AI SUMMARIES "
                          : "GENERATE AI SUMMARIES"
                      }
                    </Button></Typography>
                )}
              </div>

            </div>
          );
        }

        private renderBottomSection(survey: ISurveyEvalResponse) {
          const { classes, coach } = this.props;
          const { directorComments, coachCommitments, parentComments } =
            this.state;
          const isChampions101 =
            survey.entryLevel >= 1 && survey.entryLevel <= 4;
          const { expectations, warmth } = survey.scaleResponseSummaries;
          const schoolData = this.getDisplaySchoolData() as any;
          const accentColor =
            schoolData && schoolData.primaryColor
              ? schoolData.primaryColor
              : undefined;
          return (
            <div>
              <Grid container={true} direction="row" spacing={2}>
                {survey.type !== TemplateType.noGridNoCoach &&
                  survey.type !== TemplateType.noGrid ? (
                  <Grid item={true} xs={isChampions101 ? 12 : 6}>
                    <Typography className={classes.header} variant="h5">
                      Wise Leadership Grid
                    </Typography>
                  </Grid>
                ) : null}
                {!isChampions101 && (
                  <Grid item={true} xs={6}>
                    <Typography className={classes.header} variant="h5">
                      Administrator Comments
                    </Typography>
                  </Grid>
                )}
                <Grid item={true} xs={12}>
                  <Grid container={true} direction="row" spacing={2}>
                    {survey.type !== TemplateType.noGridNoCoach &&
                      survey.type !== TemplateType.noGrid ? (
                      <Grid item={true} xs={isChampions101 ? 12 : 6}>
                        <div
                          style={{
                            border: "1px solid #d3d3d3",
                            borderRadius: 5,
                            maxWidth: 420,
                            width: "100%",
                          }}
                        >
                          <WiseLeadershipGridChart
                            warmth={warmth.studentTotalAverage}
                            expectations={expectations.studentTotalAverage}
                            label={coach.name}
                            accentColor={accentColor}
                            coachWarmth={warmth.coachTotalAverage}
                            coachExpectations={expectations.coachTotalAverage}
                            isAdSurvey={this.isAdSurvey()}
                          />
                        </div>
                      </Grid>
                    ) : null}
                    {!isChampions101 && (
                      <Grid item={true} xs={6}>
                        <textarea
                          className={classes.textInput}
                          rows={10}
                          style={{ resize: "vertical" }}
                          value={directorComments}
                          onChange={this.directorCommentsChange}
                          maxLength={900}
                        />
                        <Button
                          disabled={this.state.loading || this.partialCleanCheck.isClean()}
                          onClick={this.updateEvaluation(false, "AD")}
                          className={classes.button}
                          color="primary"
                          variant="contained"
                        >
                          Save AD Comments
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              {!survey.enableParentQuestions && !isChampions101 ? (
                <>
                  <Typography className={classes.header} variant="h5">
                    Parent Comments
                  </Typography>
                  <Grid container={true} direction="row">
                    <Grid item={true} xs={12}>
                      <textarea
                        className={classes.textInput}
                        rows={5}
                        style={{ resize: "none" }}
                        value={parentComments}
                        onChange={this.parentCommentsChange}
                      />
                    </Grid>
                  </Grid>
                </>
              ) : survey.enableParentQuestions ? (
                <>
                  <Typography className={classes.header} variant="h5">
                    Parent Surveys
                  </Typography>
                  {this.renderQuestionsTable(survey, "parent", "Parent")}
                  {this.renderCommentsGraph(survey, "parent", "Parent", true)}
                </>
              ) : null}
              {!isChampions101 && survey.type !== TemplateType.noGridNoCoach ? (
                <>
                  <Typography className={classes.header} variant="h5">
                    {this.isAdSurvey() ? "AD" : "Coach"} {" "}
                    Commitments
                  </Typography>
                  <Grid container={true} direction="row">
                    <Grid item={true} xs={12}>
                      <textarea
                        className={classes.textInput}
                        rows={5}
                        style={{ resize: "none" }}
                        value={coachCommitments}
                        onChange={this.coachCommitmentsChange}
                        maxLength={1200}
                      />
                    </Grid>
                  </Grid>
                </>
              ) : null}
            </div>
          );
        }
        private endEvaluation = async (): Promise<void> => {
          try {
            const { school, sport, coach } = this.props;
            await this.buildPost<IEvaluationRequest, ISurveyResponse>(
              this,
              "survey/end"
            )({
              schoolId: school.id,
              sportId: sport.id,
              coachId: coach?.id ?? -1
              // ...(midSeasonCheckin && { coachId: coach?.id })
            });
          } catch (error) {
            console.error("Error during endEvaluation:", error);
          }
        };


        private readonly updateEvaluation =
          (toggleSubmitted: boolean, status: string) => (): void =>
            void this.runCancellableStatefulAsync(
              this,
              {
                loading: true,
                loadingError: undefined,
              },
              {},
              async () => {
                const {
                  coachCommitments,
                  directorComments,
                  parentComments,
                  submitted,
                } = this.state;
              let payload: Partial<ISurveyCoachEvaluationRequest>;

        if (status === "AD") {
          // Only director comment send
          payload = {
            coachCommitments,
            directorComments,
            parentComments,
            schoolId: this.props.school.id,
            submitted: toggleSubmitted ? !submitted : submitted,
          };
        } else {
          // Full payload send
          payload = {
            coachCommitments,
            directorComments,
            parentComments,
            schoolId: this.props.school.id,
            submitted: toggleSubmitted ? !submitted : submitted,
          };
        }

                console.log("save comments", this.state)
                await this.buildPut<Partial<ISurveyCoachEvaluationRequest>, void>(
                  this,
                  l`survey/${this.props.surveyId}/evaluation/${this.props.coach.id}`
                )(payload);
                await this.loadAsync();
                await this.endEvaluation();
              },
              () => {
                this.setState({
                  loading: undefined,
                  loadingError: true,
                });
              }
            );

        private readonly setPrintEvaluation = (
          printEvaluation: PrintEvaluationFunc | null
        ) => {
          this.printEvaluation =
            printEvaluation === null ? undefined : printEvaluation;
          this.setState({
            showPrintButton: this.printEvaluation && true,
          });
        };

        private readonly getParsedCoachReportPayload = (reportRow: any) => {
          const payload = reportRow && reportRow.chatgptChangeResposne;

          if (!payload) {
            return null;
          }

          if (typeof payload === "string") {
            try {
              return JSON.parse(payload.replace(/[\r\n]+/g, ""));
            } catch (error) {
              console.warn("Invalid coach report payload:", payload);
              return null;
            }
          }

          return payload;
        };

        private readonly isCoachFrontendShapeReport = (payload: any): boolean => {
          if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
            return false;
          }

          // Same detection as reportGeneratemodal: structured coach-report = new design.
          return (
            typeof payload.overallSummary === "string" ||
            Array.isArray(payload.highlightsStrengths) ||
            Array.isArray(payload.suggestions) ||
            Array.isArray(payload.resources) ||
            !!payload.teamConnectedness ||
            !!payload.wiseLeadership ||
            !!payload.expectations ||
            !!payload.relationalWarmth ||
            !!payload.parentFeedback ||
            typeof payload.finalNote === "string"
          );
        };

        private handleGenerateSummary = async (questions: any[], summaryType: 'student' | 'parent') => {
          const currentSurvey = this.state.survey;
          if (
            currentSurvey &&
            currentSurvey.entryLevel >= 1 &&
            currentSurvey.entryLevel <= 4
          ) {
            return;
          }
          const { school, sport, coach, surveyId } = this.props;
          let summaryGenerated = false; // Flag to track if a summary was generated

          // Set loading to true before starting the process
          this.setState({ loading: true, showLoader: true }); // <-- show loader

          try {
            // Fetch comments related to the survey
            const surveyComments = await this.buildGetWithParams<ISurveyComments, IDirectorParams>(
              this,
              `survey/comments/${surveyId}/${sport.id}/${coach.id}`
            )({
              schoolSlug: school.slug,
            });

            // Iterate through the questions array and gather comments for each question
            for (const question of questions) {
              const questionComments = surveyComments.questions.find(q => q.surveyQuestion.id === question.id);

              if (!questionComments) {
                // console.error("No comments found for the specified question ID:", question.id);
                continue; // Skip to the next question if no comments are found
              }

              // Separate student and parent comments
              const studentComments = questionComments.studentResponses.map(response => response.response.trim());
              const parentComments = questionComments.parentResponses.map(response => response.response.trim());

              // Check the summaryType and only generate the corresponding summary
              if (summaryType === 'student' && studentComments.length > 0) {
                const bulletPoints = studentComments.length >= 9 ? 3 : 2;
                const numberedStudentComments = studentComments.map((comment, index) => `${index + 1}. ${comment}`).join('\n');
                    const studentPrompt = `
                      Based on the following question and comments, generate exactly ${bulletPoints} bullet point summaries. Each bullet point must include a clear heading of 15 words or less, followed by a concise summary.

                      Your response must strictly follow this numbered list format:
                      1. HEADING 1: Summary point in 15 words or less.
                      2. HEADING 2: Summary point in 15 words or less.
                      ${bulletPoints === 3 ? '3. HEADING 3: Summary point in 15 words or less.' : ''}

                      Instructions:
                      - Each bullet point must start with a clear and descriptive heading, followed by the summary.
                      - The summary must be concise and not exceed 15 words.
                      - Ensure proper formatting without using hyphens, asterisks, or unnecessary symbols.
                      - Always include a heading for every bullet point.
                      - Do not add any blank lines between bullet points. Each bullet point should be on its own line, with no extra spaces or newlines.

                      Question: ${question.studentText}

                      Comments:
                      ${numberedStudentComments}
                      `;
                const studentResponse = await this.callChatGPT(studentPrompt);

                if (studentResponse && studentResponse.choices && studentResponse.choices.length > 0) {
                  let studentContent = studentResponse.choices[0].message.content;
                  // Normalize: remove blank lines, trim each line, join with single newline
                  studentContent = studentContent
                    .split('\n')
                    .map((line: string) => line.trim())
                    .filter((line: string) => line.length > 0)
                    .join('\n');
                    studentContent = formatSummaryHeadings(studentContent);
                  const responseSummary = surveyComments.responseSummaries.find(
                    (rs) => rs.surveyQuestionId === question.id
                  );
                  // let modifiedContent = studentContent;
                  // // Use regular expression to remove any dashes, numbers, or other unwanted characters
                  // modifiedContent = modifiedContent
                  //   .split("\n") // Split the content into lines
                  //   .map((line: any) => line.trim()) // Trim any extra spaces at the start or end of the line
                  //   .map((line: any) => line.replace(/^[\s*-]*\s?/, '● ')) // Replace anything before the bullet with '● '
                  //   .join("\n"); // Join the lines back together
                  // // Save the modified content in the state
                  if (responseSummary) {
                    responseSummary.studentSummary = studentContent; // Update student summary
                    summaryGenerated = true; // Set flag to true since a summary is generated
                  }
                  const chatGptRequest: IChatGptRequest = {
                    coach_id: coach.id,
                    school_id: school.id,
                    total_tokens: studentResponse.usage.total_tokens.toString(),
                    completion_tokens: studentResponse.usage.completion_tokens.toString(),
                    prompt_tokens: studentResponse.usage.prompt_tokens.toString(),
                    chatgpttoken: studentResponse.id,
                    chatgptRequest: studentPrompt,
                    chatgptResponse: studentContent
                  };
                  // save the chat history
                  await this.saveChatGptHistory(chatGptRequest);

                }
              }

              // Generate summaries for parent comments if available
              if (summaryType === 'parent' && parentComments.length > 0) {
                const bulletPoints = parentComments.length >= 9 ? 3 : 2;
                const numberedParentComments = parentComments.map((comment, index) => `${index + 1}. ${comment}`).join('\n');
                    const parentPrompt = `
                      Based on the following question and comments, generate exactly ${bulletPoints} bullet point summaries. Each bullet point must include a clear heading of 15 words or less, followed by a concise summary.
                      
                      Your response must strictly follow this numbered list format:
                      1. HEADING 1: Summary point in 15 words or less.
                      2. HEADING 2: Summary point in 15 words or less.
                      ${bulletPoints === 3 ? '3. HEADING 3: Summary point in 15 words or less.' : ''}
                      
                      Instructions:
                      - Each bullet point must start with a clear and descriptive heading, followed by the summary.
                      - The summary must be concise and not exceed 15 words.
                      - Ensure proper formatting without using hyphens, asterisks, or unnecessary symbols.
                      - Always include a heading for every bullet point.
                      - Do not add any blank lines between bullet points. Each bullet point should be on its own line, with no extra spaces or newlines.
                      
                      Question: ${question.parentText}
                      
                      Comments:
                      ${numberedParentComments}
                      `;

                const parentResponse = await this.callChatGPT(parentPrompt);

                if (parentResponse && parentResponse.choices && parentResponse.choices.length > 0) {
                  let parentContent = parentResponse.choices[0].message.content;
                  // Normalize: remove blank lines, trim each line, join with single newline
                  parentContent = parentContent
                    .split('\n')
                    .map((line: string) => line.trim())
                    .filter((line: string) => line.length > 0)
                    .join('\n');
                    parentContent = formatSummaryHeadings(parentContent);
                  const responseSummary = surveyComments.responseSummaries.find(
                    (rs) => rs.surveyQuestionId === question.id
                  );
                  // let modifiedContent = parentContent;
                  // // Use regular expression to remove any dashes, numbers, or other unwanted characters
                  // modifiedContent = modifiedContent
                  //   .split("\n") // Split the content into lines
                  //   .map((line: any) => line.trim()) // Trim any extra spaces at the start or end of the line
                  //   .map((line: any) => line.replace(/^[\s*-]*\s?/, '● ')) // Replace anything before the bullet with '● '
                  //   .join("\n"); // Join the lines back together
                  // // Save the modified content in the state
                  if (responseSummary) {
                    responseSummary.parentSummary = parentContent; // Update parent summary
                    summaryGenerated = true; // Set flag to true since a summary is generated
                  }

                  const chatGptRequest: IChatGptRequest = {
                    coach_id: coach.id,
                    school_id: school.id,
                    total_tokens: parentResponse.usage.total_tokens.toString(),
                    completion_tokens: parentResponse.usage.completion_tokens.toString(),
                    prompt_tokens: parentResponse.usage.prompt_tokens.toString(),
                    chatgpttoken: parentResponse.id,
                    chatgptRequest: parentPrompt,
                    chatgptResponse: parentContent
                  };
                  // save the chat history
                  await this.saveChatGptHistory(chatGptRequest);
                }
              }
            }

            // Only proceed to save the summaries and reload the state if a summary was generated
            if (summaryGenerated) {
              // Save the updated summaries to the API
              await this.buildPut<IResponseSummaryRequest, void>(
                this,
                `response/summary`
              )({
                schoolId: school.id,
                summaries: surveyComments.responseSummaries,
              });

              // Optionally reload the state after each save
              await this.loadAsync();
            } else {
              alert("Summary not generated: No responses found for the selected question.");

            }

          } catch (error) {
            console.error("Error generating summary:", error);
            this.setState({
              loadingError: true,
            });
          } finally {
            // Set loading to undefined after the process completes
            this.setState({ loading: undefined, showLoader: false }); // <-- hide loader
          }
        };
// 👇 Closure function
// public createGenerateHandler = (component: any) => {
//   // yaha polyfill ek hi bar define hoga
//   if (!(Promise as any).allSettled) {
//     (Promise as any).allSettled = (promises: any[]) =>
//       Promise.all(
//         promises.map((p) =>
//           Promise.resolve(p).then(
//             (value) => ({ status: "fulfilled", value }),
//             (reason) => ({ status: "rejected", reason })
//           )
//         )
//       );
//   }

//   // closure return karega ek handler
//   return async () => {
//     const { survey } = component.state;

//     if (survey && survey.questions) {
//       const promises = [
//         component.GenerateSummaryHandle(survey.questions, "student"),
//         component.GenerateSummaryHandle(survey.questions, "parent"),
//         (component as any)._childGenerateReport?.(),
//       ];

//       const results = await (Promise as any).allSettled(promises);

//       results.forEach((res: any, idx: number) => {
//         if (res.status === "fulfilled") {
//           console.log(`API ${idx + 1} success ✅`, res.value);
//         } else {
//           console.error(`API ${idx + 1} failed ❌`, res.reason);
//         }
//       });

//       component.openReoprtModal(true);
//       component.setState({ confirmGenerateReportOpen: false });
//     }
//   };
// };



        private GenerateSummaryHandle = async (questions: any[], summaryType: 'student' | 'parent') => {

          const currentSurvey = this.state.survey;
          if (
            currentSurvey &&
            currentSurvey.entryLevel >= 1 &&
            currentSurvey.entryLevel <= 4
          ) {
            return;
          }

          const { school, sport, coach, surveyId } = this.props;
          let summaryGenerated = false; // Flag to track if a summary was generated
          if(summaryType === 'student'){
            this.setState({ loading: true, showLoaderStudent: true }); // <-- show loader

            // console.log("student summary is called")
            
          }else{
            this.setState({ loading: true, showLoaderParent: true }); // <-- show loader

            // console.log("parent summary is called")
          }
          // Set loading to true before starting the process
          // this.setState({ loading: true, showLoader: true }); // <-- show loader


          try {
            // Fetch comments related to the survey
            const surveyComments = await this.buildGetWithParams<ISurveyComments, IDirectorParams>(
              this,
              `survey/comments/${surveyId}/${sport.id}/${coach.id}`
            )({
              schoolSlug: school.slug,
            });

            // Iterate through the questions array and gather comments for each question
            for (const question of questions) {
              const questionComments = surveyComments.questions.find(q => q.surveyQuestion.id === question.id);

              if (!questionComments) {
                console.error("No comments found for the specified question ID:", question.id);
                continue; // Skip to the next question if no comments are found
              }

              // Separate student and parent comments
              const studentComments = questionComments.studentResponses.map(response => response.response.trim());
              const parentComments = questionComments.parentResponses.map(response => response.response.trim());

              // Check the summaryType and only generate the corresponding summary
              if (summaryType === 'student' && studentComments.length > 0) {
                const bulletPoints = studentComments.length >= 9 ? 3 : 2;
                const numberedStudentComments = studentComments.map((comment, index) => `${index + 1}. ${comment}`).join('\n');
                const studentPrompt = `
                      Based on the following question and comments, generate exactly ${bulletPoints} bullet point summaries. Each bullet point must include a clear heading of 15 words or less, followed by a concise summary.

                      Your response must strictly follow this numbered list format:
                      1. HEADING 1: Summary point in 15 words or less.
                      2. HEADING 2: Summary point in 15 words or less.
                      ${bulletPoints === 3 ? '3. HEADING 3: Summary point in 15 words or less.' : ''}

                      Instructions:
                      - Each bullet point must start with a clear and descriptive heading, followed by the summary.
                      - The summary must be concise and not exceed 15 words.
                      - Ensure proper formatting without using hyphens, asterisks, or unnecessary symbols.
                      - Always include a heading for every bullet point.

                      Question: ${question.studentText}

                      Comments:
                      ${numberedStudentComments}
                      `;


                const studentResponse = await this.callChatGPT(studentPrompt);

                if (studentResponse && studentResponse.choices && studentResponse.choices.length > 0) {
                  let studentContent = studentResponse.choices[0].message.content;
                  studentContent = studentContent
                    .split('\n')
                    .map((line: string) => line.trim())
                    .filter((line: string) => line.length > 0)
                    .join('\n');
                  studentContent = formatSummaryHeadings(studentContent);
                  const responseSummary = surveyComments.responseSummaries.find(
                    (rs) => rs.surveyQuestionId === question.id
                  );
                  // let modifiedContent = studentContent;
                  // // Use regular expression to remove any dashes, numbers, or other unwanted characters
                  // modifiedContent = modifiedContent
                  //   .split("\n") // Split the content into lines
                  //   .map((line: any) => line.trim()) // Trim any extra spaces at the start or end of the line
                  //   .map((line: any) => line.replace(/^[\s*-]*\s?/, '● ')) // Replace anything before the bullet with '● '
                  //   .join("\n"); // Join the lines back together
                  // // Save the modified content in the state
                  if (responseSummary) {
                    responseSummary.studentSummary = studentContent; // Update student summary
                    summaryGenerated = true; // Set flag to true since a summary is generated
                  }
                  const chatGptRequest: IChatGptRequest = {
                    coach_id: coach.id,
                    school_id: school.id,
                    total_tokens: studentResponse.usage.total_tokens.toString(),
                    completion_tokens: studentResponse.usage.completion_tokens.toString(),
                    prompt_tokens: studentResponse.usage.prompt_tokens.toString(),
                    chatgpttoken: studentResponse.id,
                    chatgptRequest: studentPrompt,
                    chatgptResponse: studentContent
                  };
                  // save the chat history
                  await this.saveChatGptHistory(chatGptRequest);

                }
              }

              // Generate summaries for parent comments if available
              if (summaryType === 'parent' && parentComments.length > 0) {
                const bulletPoints = parentComments.length >= 9 ? 3 : 2;
                const numberedParentComments = parentComments.map((comment, index) => `${index + 1}. ${comment}`).join('\n');
                const parentPrompt = `
                      Based on the following question and comments, generate exactly ${bulletPoints} bullet point summaries. Each bullet point must include a clear heading of 15 words or less, followed by a concise summary.
                      
                      Your response must strictly follow this numbered list format:
                      1. HEADING 1: Summary point in 15 words or less.
                      2. HEADING 2: Summary point in 15 words or less.
                      ${bulletPoints === 3 ? '3. HEADING 3: Summary point in 15 words or less.' : ''}
                      
                      Instructions:
                      - Each bullet point must start with a clear and descriptive heading, followed by the summary.
                      - The summary must be concise and not exceed 15 words.
                      - Ensure proper formatting without using hyphens, asterisks, or unnecessary symbols.
                      - Always include a heading for every bullet point.
                      
                      Question: ${question.parentText}
                      
                      Comments:
                      ${numberedParentComments}
                      `;

                const parentResponse = await this.callChatGPT(parentPrompt);

                if (parentResponse && parentResponse.choices && parentResponse.choices.length > 0) {
                  let parentContent = parentResponse.choices[0].message.content;
                  parentContent = parentContent
                    .split('\n')
                    .map((line: string) => line.trim())
                    .filter((line: string) => line.length > 0)
                    .join('\n');
                  parentContent = formatSummaryHeadings(parentContent);
                  const responseSummary = surveyComments.responseSummaries.find(
                    (rs) => rs.surveyQuestionId === question.id
                  );
                  // let modifiedContent = parentContent;
                  // // Use regular expression to remove any dashes, numbers, or other unwanted characters
                  // modifiedContent = modifiedContent
                  //   .split("\n") // Split the content into lines
                  //   .map((line: any) => line.trim()) // Trim any extra spaces at the start or end of the line
                  //   .map((line: any) => line.replace(/^[\s*-]*\s?/, '● ')) // Replace anything before the bullet with '● '
                  //   .join("\n"); // Join the lines back together
                  // // Save the modified content in the state
                  if (responseSummary) {
                    responseSummary.parentSummary = parentContent; // Update parent summary
                    summaryGenerated = true; // Set flag to true since a summary is generated
                  }

                  const chatGptRequest: IChatGptRequest = {
                    coach_id: coach.id,
                    school_id: school.id,
                    total_tokens: parentResponse.usage.total_tokens.toString(),
                    completion_tokens: parentResponse.usage.completion_tokens.toString(),
                    prompt_tokens: parentResponse.usage.prompt_tokens.toString(),
                    chatgpttoken: parentResponse.id,
                    chatgptRequest: parentPrompt,
                    chatgptResponse: parentContent
                  };
                  // save the chat history
                  await this.saveChatGptHistory(chatGptRequest);
                }
              }
            }

            // Only proceed to save the summaries and reload the state if a summary was generated
            if (summaryGenerated) {
              // Save the updated summaries to the API
              await this.buildPut<IResponseSummaryRequest, void>(
                this,
                `response/summary`
              )({
                schoolId: school.id,
                summaries: surveyComments.responseSummaries,
              });

              // Optionally reload the state after each save
              await this.loadAsync();
            } else {
              alert(`Summary not generated for ${summaryType}: Due to insufficient data, the summary could not be generated. However, your report generation is in progress...`)
              // alert(`summary not generated for ${summaryType}: due to insufficient data summary is not generated but your report generation is in progress....`)
              // alert(`Summary not generated for ${summaryType}: No responses found for the selected question. Your report can still be generated and is still in progress.`);


            }

          } catch (error) {
            console.error("Error generating summary:", error);
            this.setState({
              loadingError: true,
            });
          } finally {
            // Set loading to undefined when done - so LinearProgress closes when Print button appears
            if(summaryType === 'parent'){
              this.setState({ loading: undefined, showLoaderParent: false });
            }
            if(summaryType === 'student'){
              this.setState({ loading: undefined, showLoaderStudent: false });
            }


            // this.setState({ loading: true, showLoaderStudent: true, showLoaderParent: true }); // <-- show loader

          }
        };

       // 👇 By default ye public hai (agar keyword na bhi lagao to)
// private async checkAutomationSummary() {
//   alert("this  function  is  called ")
  
//   const { survey } = this.state;

//   // Modal open karo
//   this.openReoprtModal(true);
//   this.setState({ editButtonLoading: false ,reportButtonCalled:true});

//   if (!survey || !survey.questions || survey.questions.length === 0) {
//     console.log("⚠️ Report generation cannot continue: No survey questions found.");
//     return;
//   }

//   try {
//     // ✅ Check if summaries already exist
//     const alreadyHasStudentSummary = survey.questions.some(
//       (q: any) => q.responseSummary && q.responseSummary.studentSummary
//     );
//     const alreadyHasParentSummary = survey.questions.some(
//       (q: any) => q.responseSummary && q.responseSummary.parentSummary
//     );

//     if (alreadyHasStudentSummary && alreadyHasParentSummary) {
//       console.log("✅ Report already generated: Student and Parent summaries exist.");
//       return;
//     }

//     // ✅ Check data availability
//     const hasStudentData = survey.questions.some(
//       (q: any) => q.studentResponses && q.studentResponses.length > 0
//     );
//     const hasParentData = survey.questions.some(
//       (q: any) => q.parentResponses && q.parentResponses.length > 0
//     );

//     if (!hasStudentData && !hasParentData) {
//       console.log("⚠️ Insufficient data: Neither student nor parent responses found.");
//       return;
//     }

//     // 2️⃣ Student summary generate (agar pehle se nahi hai)
//     if (!alreadyHasStudentSummary) {
//       if (hasStudentData) {
//         await this.GenerateSummaryHandle(survey.questions, "student");
//       } else {
//         console.log("⚠️ Student summary not generated: No student responses found.");
//       }
//     }

//     // 3️⃣ Parent summary generate (agar pehle se nahi hai)
//     if (!alreadyHasParentSummary) {
//       if (hasParentData) {
//         await this.GenerateSummaryHandle(survey.questions, "parent");
//       } else {
//         console.log("⚠️ Parent summary not generated: No parent responses found.");
//       }
//     }

//   } catch (error) {
//     console.log("❌ An error occurred while generating the report. Please try again later.");
//   } finally {
//     // Confirm dialog close
//     this.setState({ confirmGenerateReportOpen: false });
//   }
// }

// private async checkAutomationSummary() {
//   // console.log(survey.id ,"testing shubham")
//   console.log(this.state,"this.state 123")
//   const { survey } = this.state;

//   // Modal open
//   this.openReoprtModal(true);
//   this.setState({ editButtonLoading: false, reportButtonCalled: true });

//   if (!survey || !survey.questions || survey.questions.length === 0) {
//     console.log("⚠️ No survey questions found.");
//     return;
//   }
//   console.log(survey,"surveysurvey")

//   try {
//     // ✅ Check if summaries already exist using writtenResponseSummaries
//     const alreadyHasStudentSummary = survey.questions.some(q =>
//       (survey.writtenResponseSummaries.find(r => r.surveyQuestionId === q.id)?.studentSummary || "").trim().length > 0
//     );

//     const alreadyHasParentSummary = survey.questions.some(q =>
//       (survey.writtenResponseSummaries.find(r => r.surveyQuestionId === q.id)?.parentSummary || "").trim().length > 0
//     );

//     console.log("Student summary exists:", alreadyHasStudentSummary);
//     console.log("Parent summary exists:", alreadyHasParentSummary);

//     // ✅ Check data availability
//     // const hasStudentData = survey.questions.some(q => q.studentResponses?.length > 0);
//     // const hasParentData = survey.questions.some(q => q.parentResponses?.length > 0);

//     // //  ✅ Check data availability
//     // const hasStudentData = survey.questions.some(
//     //   (q: any) => q.studentResponses && q.studentResponses.length > 0
//     // );
//     // const hasParentData = survey.questions.some(
//     //   (q: any) => q.parentResponses && q.parentResponses.length > 0
//     // );


//     // console.log("Has student data:", hasStudentData);
//     // console.log("Has parent data:", hasParentData);

//     // Generate summaries only if needed
//     if (!alreadyHasStudentSummary) {
//       console.log("Generating student summary...");
//       await this.GenerateSummaryHandle(survey.questions, "student");
//     }

//     if (!alreadyHasParentSummary) {
//       console.log("Generating parent summary...");
//       await this.GenerateSummaryHandle(survey.questions, "parent");
//     }

//   } catch (error) {
//     console.error("❌ Error generating summaries:", error);
//   } finally {
//     this.setState({ confirmGenerateReportOpen: false });
//   }
// }


// private async checkAutomationSummary() {
//   const { survey } = this.state;
//   this.openReoprtModal(true);
//   this.setState({ editButtonLoading: false, reportButtonCalled: true });

//   if (!survey || !survey.questions || survey.questions.length === 0) {
//     console.log("⚠️ Report generation cannot continue: No survey questions found.");
//     return;
//   }

//   try {
//     // Check if **any student summary is missing**
//     const needStudentSummary = survey.writtenResponseSummaries.some(
//       r => !r.studentSummary?.trim()
//     );

//     // Check if **any parent summary is missing**
//     const needParentSummary = survey.writtenResponseSummaries.some(
//       r => !r.parentSummary?.trim()
//     );

//     if (!needStudentSummary && !needParentSummary) {
//       console.log("✅ All summaries already generated.");
//       return;
//     }

//     // Generate student summary if needed
//     if (needStudentSummary) {
//       console.log("Student summary generation started");
//       await this.GenerateSummaryHandle(survey.questions, "student");
//     }

//     // Generate parent summary if needed
//     if (needParentSummary) {
//       console.log("Parent summary generation started");
//       await this.GenerateSummaryHandle(survey.questions, "parent");
//     }

//   } catch (error) {
//     console.log("❌ Error generating summaries:", error);
//   } finally {
//     this.setState({ confirmGenerateReportOpen: false });
//   }
// }

private async checkAutomationSummary() {
  const { survey } = this.state;
  this.openReoprtModal(true);
  this.setState({ editButtonLoading: false, reportButtonCalled: true });

  if (!survey || !survey.questions || survey.questions.length === 0) {
    console.log("⚠️ Report generation cannot continue: No survey questions found.");
    return;
  }

  try {

    // Get all existing student summaries
    const existingStudentSummaries = survey.writtenResponseSummaries
      .map(r => r.studentSummary?.trim())
      .filter(s => s && s.length > 0);


    // Get all existing parent summaries
    const existingParentSummaries = survey.writtenResponseSummaries
      .map(r => r.parentSummary?.trim())
      .filter(s => s && s.length > 0);

    // Log existing summaries
    if (existingStudentSummaries.length > 0) {
      console.log("Existing Student Summaries:");
      existingStudentSummaries.forEach((s, i) => console.log(`${i + 1}: ${s}`));
    }

    if (existingParentSummaries.length > 0) {
      console.log("Existing Parent Summaries:");
      existingParentSummaries.forEach((s, i) => console.log(`${i + 1}: ${s}`));
    }

    // If **any summary exists**, skip generation
    if (existingStudentSummaries.length > 0 || existingParentSummaries.length > 0) {
      console.log("✅Student At least one summary already exists. Skipping generation.");
      // return;
    }
    else{
      await this.GenerateSummaryHandle(survey.questions, "student");

    }

    if ( existingParentSummaries.length > 0) {
      console.log("✅ parent At least one summary already exists. Skipping generation.");
      // return;
    }else{
      await this.GenerateSummaryHandle(survey.questions, "parent");
    }

    // Generate summaries if none exist
    console.log("Generating all summaries...");

  } catch (error) {
    console.log("❌ Error generating summaries:", error);
  } finally {
    this.setState({ confirmGenerateReportOpen: false });
  }
}

        private callChatGPT = async (prompt: string) => {
        
          const data = {
            model: "gpt-4.1-mini",
            // temperature: 1,
            messages: [
              {
                role: "system",
                content: prompt
              }
            ]
          };

          // Call API using buildPost
          const jsonData = await this.buildPost<any, any>(
            this,
            "chatgpt/openAI/completions"
          )(data);


          return jsonData;
        };

        // private callChatGPT = async (prompt: string) => {
        //   console.log("prompt", prompt);

        //   const requestBody = {
        //     model: "gpt-4.1-mini",
        //     temperature: 1,
        //     messages: [
        //       {
        //         role: "system",
        //         content: prompt
        //       }
        //     ]
        //   };

        //   try {
        //     // Use buildPost instead of raw fetch
        //     const response = await this.buildPost<any, any>(
        //       this,
        //       "chatgpt/openAI/completions"
        //     )(requestBody);

        //     console.log("ChatGPT API response:", response);
        //     return response;

        //   } catch (error) {
        //     console.error("Error calling ChatGPT API:", error);
        //     throw error;
        //   }
        // };


        private readonly loadAsync = async () => {
          await this.runCancellableStatefulAsync(
            this,
            {
              loading: true,
              loadingError: undefined,
            },
            {
              loading: undefined,
            },
            async () => {
              const survey = await this.buildGetWithParams<
                ISurveyEvalResponse,
                ISurveyEvaluationRequest
              >(
                this,
                l`survey/${this.props.surveyId}/evaluation/${this.props.coach.id}`
              )({
                isParentResponses: "false",
                schoolSlug: this.props.school.slug,
              });

          

              this.setState((oldState) => {
                const newState = {
                  coachCommitments: survey.coachCommitments,
                  directorComments: survey.directorComments,
                  parentComments: survey.parentComments,
                  submitted: survey.submitted,
                  survey,
                };
                this.partialCleanCheck.setOldFormData(newState);
                return newState;
              });
            },
            () => {
              this.setState({
                loading: undefined,
                loadingError: true,
              });
              console.error('[loadAsync] failed to load evaluation data');
            }
          );
        };
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/EvaluationPage/EvaluationPage.tsx